module.exports = __webpack_public_path__ + "static/media/wallet.f35ac114.svg";